import { ListGuesser, EditGuesser, ShowGuesser } from "react-admin";

import CampaignIcon from "@mui/icons-material/Whatshot";

import FundraisersCampaignCreate from "./FundraisersCampaignCreate";
import FundraisersCampaignList from "./FundraisersCampaignList";
import FundraisersCampaignEdit from "./FundraisersCampaignEdit";
import FundraisersCampaignShow from "./FundraisersCampaignShow";

const FundraisersCampaignResourceProps = {
	name: "fundraisers_campaign",
	list: FundraisersCampaignList,
	create: FundraisersCampaignCreate,
	edit: FundraisersCampaignEdit,
	show: FundraisersCampaignShow,
};

export const FundraisersCampaignMenuProps = {
	to: "/fundraisers_campaign",
	primaryText: "Fundraisers Campaign",
	icon: CampaignIcon,
};

export default FundraisersCampaignResourceProps;
